/**
 * The currency input component default options.
 *
 * @type {Object.<string, string>}
 */
export const CURRENCY_INPUT_DEFAULTS = Object.freeze({
  currency: null,
  precision: 0,
  locale: 'en-US',
  allowNegative: false,
});
